import React, { useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import InboxTable from "./InboxTable";
import ArchivedTable from "./ArchivedTable";
import OutboxTable from "./OutboxTable";
import { hasAccess } from "util/sidebar";
import { MODULE_NAMES, PERMISSION_TYPE } from "helper/constant";

const EfaxViewDetails = props => {
  const { permissions } = props;
  const [activeTab, setActiveTab] = useState("1");
  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="plr-15">
      <div className="roe-card-style mtb-15">
        <div className="roe-card-header module-header">
          <div className="flex-1 fs-16 demi-bold-text cursor-pointer">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames(
                    { active: activeTab === "1" },
                    "doc-title"
                  )}
                  onClick={() => {
                    toggle("1");
                  }}
                  disabled={
                    !hasAccess(
                      MODULE_NAMES.EFAX_INBOX,
                      PERMISSION_TYPE.VIEW,
                      permissions
                    )
                  }
                >
                  Inbox
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames(
                    { active: activeTab === "2" },
                    "doc-title"
                  )}
                  onClick={() => {
                    toggle("2");
                  }}
                  disabled={
                    !hasAccess(
                      MODULE_NAMES.EFAX_ARCHIVE,
                      PERMISSION_TYPE.VIEW,
                      permissions
                    )
                  }
                >
                  Archived
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames(
                    { active: activeTab === "3" },
                    "doc-title"
                  )}
                  onClick={() => {
                    toggle("3");
                  }}
                  disabled={
                    !hasAccess(
                      MODULE_NAMES.EFAX_OUTBOX,
                      PERMISSION_TYPE.VIEW,
                      permissions
                    )
                  }
                >
                  Outbox
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
        <div className="roe-card-body">
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <InboxTable {...props} />
            </TabPane>
            <TabPane tabId="2">
              <ArchivedTable {...props} />
            </TabPane>
            <TabPane tabId="3">
              <OutboxTable {...props} />
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};
export default EfaxViewDetails;
